import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type AutoplayModuleSpecsFragment } from '../../../../api/fragments/AutoplayModuleSpecs';
import AutoplaySettingActions from './AutoplaySettingActions';

export type AutoplaySettingsTableProps = {
    module: AutoplayModuleSpecsFragment;
};

export type AutoplaySettingSpecs = AutoplayModuleSpecsFragment['settings'][number];

const AutoplaySettingsTable = ({ module }: AutoplaySettingsTableProps) => {
    const { t } = useTranslation(['autoplayModuleDetails']);

    const renderActions = useCallback(
        (record: AutoplaySettingSpecs) => <AutoplaySettingActions module={module} setting={record} />,
        [module]
    );

    return (
        <Table dataSource={module.settings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('autoplayModuleDetails:autoplaySettingsTable.columns.displayName')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('autoplayModuleDetails:autoplaySettingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default AutoplaySettingsTable;
